import { joinCn } from '../util';

const style = {
  switch(checked: boolean) {
    return joinCn(
      'relative h-[22px] w-[45px] rounded-full transition-colors duration-300 ease-in-out',
      {
        'bg-secondary-300': checked,
        'bg-gray-300': !checked,
      },
    );
  },

  contentContainer() {
    return joinCn('absolute inset-0.5 flex items-center');
  },

  thumb(checked: boolean, disabled: boolean) {
    return joinCn(
      'absolute size-4 shrink-0 rounded-full shadow-sm transition-transform duration-300 ease-in-out',
      {
        'bg-white': !disabled,
        'bg-gray-300': disabled,
        'translate-x-0': !checked,
        'translate-x-[25px]': checked,
      },
    );
  },

  text(checked: boolean, disabled: boolean) {
    return joinCn(
      'absolute flex w-[23px] items-center justify-center text-body-ss font-semibold transition-all duration-300 ease-in-out',
      {
        'text-white': !disabled,
        'text-gray-400': disabled,
        'right-0.5': !checked,
        'left-0.5': checked,
      },
    );
  },
};

export default style;
